import { Box } from '@mui/material';
import { fontWeight, styled, textAlign } from '@mui/system';
import { Colors } from '../theme/index.js';
 

export const AdminDashboardContainer = styled(Box)(() => ({
  padding: '10px',
  backgroundColor: Colors.background,
  minHeight: '100vh',

  '& .dashboard-container': {
    padding: '24px',
    backgroundColor: Colors.background,
    borderRadius: '10px',
    boxShadow: '0 4px 10px Colors.shadow',
  },
  '& .dashboard-card': {
    height: '100%',
    borderRadius: '8px',
  },
  '& .chart-box': {
    height: '300px',
    display: 'flex',               
    justifyContent:'center',       
    alignItems: 'center',        
    
  },

  '& .title_card': {
    textAlign: 'center',
    fontWeight: 'bold',
  },
}));

 